// @flow
import * as types from 'app/common/constants/identifiers/types';
import * as statuses from 'app/common/constants/identifiers/statuses';

import type { Request } from '../../../index';


type Params = {
  student_id: number | string,
  number: string,
}

type ResultApi = {
  result: 'success',
  [id: string]: {
    id: number,
    cardholder_type: 'Student',
    cardholder_id: number,
    w26: string | null,
    w34: string | null,
    w58: string | null,
    number: string | null,
    type: $Values<typeof types>,
    cost: string,
    paid: string,
    is_cafe_card: boolean,
    is_access_card: boolean,
    status: $Values<typeof statuses>,
    modules: Array<'access' | 'cafeteria'>,
    created: string,
    updated: string,
    status_expiry: string | null,
    comment: string | null,
    unblock_disabled: boolean,
  }
}

export const POST_IDENTIFIERS_PREPAID_APPEND: Request<
  Params,
  ResultApi,
  void
> = [
  'cabinet/identifiers/prepaid/append',
  'post',
  ['data'],
];
